<template>
  <ux-form
    ref="form"
    class="x-padding-x"
    style="width: 360px"
    :colon="true"
    :data="formData"
    :rules="rules"
    label-width="60px"
    data-automation="editPassword"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item v-if="!isAdmin" :label="$t('HT.oldPassword')" prop="oldPassword">
      <ux-input
        v-model="formData.oldPassword"
        type="password"
        :maxlength="18"
        show-password
        size="small"
        :placeholder="$t('HT.passwdPlaceholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.newPassword')" prop="password">
      <ux-input
        v-model="formData.password"
        type="password"
        :maxlength="18"
        show-password
        size="small"
        :placeholder="$t('HT.passwdPlaceholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.passwdCheck')" prop="passwdCheck">
      <ux-input
        v-model="formData.passwdCheck"
        type="password"
        :maxlength="18"
        show-password
        size="small"
        :placeholder="$t('HT.passwdPlaceholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  name: 'EditPassword',
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        oldPassword: '',
        password: '',
        passwdCheck: ''
      },
      rules: this.$rul.register(this)
    };
  },

  methods: {
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-password {
  width: 350px;
}
</style>
